// Parent Component (BillList.jsx)
import React from "react";
import styled from "@emotion/styled";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Grid,
  Link,
} from "@mui/material";
import { Box, spacing } from "@mui/system";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PendingBills from "./PendingBills";
import AllBills from "./AllBills";
import { hasAnyRole } from "../../utils/auth";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const BillList = () => {
  const canViewPendingBills = hasAnyRole(["Admin", "Developer"]);
  const [value, setValue] = React.useState(canViewPendingBills ? "1" : "2");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <Helmet title="Bills" />

      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Bills
          </Typography>
          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/">
              Dashboard
            </Link>
            <Typography>Bills</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      {/*       <Divider my={6} /> */}
      <Box sx={{ width: "100%", typography: "body1", marginTop: 10 }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="payments tab">
              {canViewPendingBills && (
                <Tab label="Unprocessed or Failed ACH Payments" value="1" />
              )}
              <Tab label="All Bills" value="2" />
            </TabList>
          </Box>
          {canViewPendingBills && (
            <TabPanel value="1">
              <PendingBills />
            </TabPanel>
          )}
          <TabPanel value="2">
            <AllBills />
          </TabPanel>
        </TabContext>
      </Box>
    </React.Fragment>
  );
};

export default BillList;
